import { useMemo } from 'react';
import { buildIframeUrl, shouldShowCarrierImages, IframeConfig } from '../utils/iframeUtils';

export interface UseIframeUrlResult {
  iframeUrl: string | null;
  showCarrierImages: boolean;
}

export const useIframeUrl = (
  proNumber: string | undefined,
  configJSON: IframeConfig | undefined
): UseIframeUrlResult => {
  const iframeUrl = useMemo(() => {
    return buildIframeUrl(proNumber, configJSON);
  }, [proNumber, configJSON?.proImagesUrl, configJSON?.proMinLengthForImage]);

  const showCarrierImages = useMemo(() => {
    return shouldShowCarrierImages(iframeUrl);
  }, [iframeUrl]);

  return {
    iframeUrl,
    showCarrierImages,
  };
};
